import apiClient from './client';

export interface GlobalSetting {
  key: string;
  value: boolean;
  description?: string | null;
  updated_at: string;
}

export interface SettingsListResponse {
  settings: GlobalSetting[];
}

export interface CreateSettingPayload {
  key: string;
  value: boolean;
  description?: string;
}

export const settingsApi = {
  async list(): Promise<SettingsListResponse> {
    const response = await apiClient.get<SettingsListResponse>('/admin/settings');
    return response.data;
  },

  async create(payload: CreateSettingPayload): Promise<GlobalSetting> {
    const response = await apiClient.post<GlobalSetting>('/admin/settings', payload);
    return response.data;
  },

  async update(key: string, value: boolean): Promise<GlobalSetting> {
    const response = await apiClient.patch<GlobalSetting>(`/admin/settings/${key}`, { value });
    return response.data;
  },

  async getByKey(key: string): Promise<GlobalSetting> {
    const response = await apiClient.get<GlobalSetting>(`/settings/${encodeURIComponent(key)}`);
    return response.data;
  },
};
